export default {"userPoolId":"us-east-1_aoujyFbBk","userPoolClientId":"39cjnqsc9902djcus49nrgpd5p","apiURL":"https://api.villa.rocks/"}
